import { QuestionCircleOutlined, RightOutlined } from '@ant-design/icons';
import { Card, Space, Switch, Tooltip, Typography } from 'antd';
import React from 'react';
import styled from 'styled-components';

const { Text, Title } = Typography;

interface AudienceAccordionProps {
  title: string;
  description: string;
  tooltip?: React.ReactNode;
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
  children?: React.ReactNode;
}

export const AudienceAccordion: React.FC<AudienceAccordionProps> = ({
  title,
  description,
  tooltip,
  enabled,
  onToggle,
  children,
}) => {
  const titleNode = (
    <Space size={6} align='center'>
      <StyledTitle level={5}>{title}</StyledTitle>
      {tooltip && (
        <Tooltip title={tooltip}>
          <QuestionCircleOutlined
            style={{ fontSize: 13, color: '#595959', cursor: 'help' }}
          />
        </Tooltip>
      )}
    </Space>
  );

  return (
    <StyledCard>
      <AccordionHeader>
        <Space align='start' size={10}>
          <ArrowIcon $open={enabled} />
          <Space direction='vertical' size={0}>
            {titleNode}
            <Text type='secondary' style={{ fontSize: 13 }}>
              {description}
            </Text>
          </Space>
        </Space>
        <Switch checked={enabled} onChange={onToggle} />
      </AccordionHeader>

      {enabled && <CollapseContent>{children}</CollapseContent>}
    </StyledCard>
  );
};

const StyledCard = styled(Card)`
  .ant-card-body {
    padding: 0;
  }
  background-color: #1f1f1f;
`;

const AccordionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  cursor: default;
  user-select: none;
`;

const ArrowIcon = styled(RightOutlined)<{ $open: boolean }>`
  font-size: 12px;
  color: #8c8c8c;
  transition: transform 0.25s ease;
  transform: ${({ $open }) => ($open ? 'rotate(90deg)' : 'rotate(0deg)')};
  flex-shrink: 0;
`;

const CollapseContent = styled.div`
  padding: 24px;
  border-top: 1px solid #303030;
`;

const StyledTitle = styled(Title)`
  && {
    margin: 0 0 2px;
    font-size: 16px;
  }
`;
